import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import LandingPage from "./LandingPage";
import Signin from "./Signin";
import RequestAccess from "./pages/RequestAccess";
import Chat from "./Chat";
import ChatEntry from "./ChatEntry";
import AdminDashboardV2 from "./AdminDashboardV2";
import GamesHub from "./GamesHub";
import StudentCurriculum from "./pages/StudentCurriculum";
import StudentTutor from "./pages/StudentTutor";
import StudentTutorSession from "./pages/StudentTutorSession";
import InvitedRegister from "./InvitedRegister";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFoundPage from "./pages/NotFoundPage";
import adminTheme from "./theme/adminTheme";
import './App.css';

function App() {
  return (
    <ThemeProvider theme={adminTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/request-access" element={<RequestAccess />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/chat" element={<ChatEntry />} />
          <Route path="/chat/:conversationId" element={<Chat />} />
          <Route path="/games" element={<GamesHub />} />
          <Route path="/admin/*" element={<AdminDashboardV2 />} />
          <Route path="/curriculum" element={<StudentCurriculum />} />
          <Route path="/tutor" element={<StudentTutor />} />
          <Route path="/tutor/:agentId" element={<StudentTutorSession />} />
          <Route path="/register" element={<InvitedRegister />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
